var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSweden = function SvgSweden(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1000,
    viewBox: "0 0 16 10",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    fill: "#006aa7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    x: 5,
    fill: "#fecc00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    y: 4,
    fill: "#fecc00"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSweden);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2MDAiIGhlaWdodD0iMTAwMCIgdmlld0JveD0iMCAwIDE2IDEwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDA2YWE3Ii8+CjxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjEwIiB4PSI1IiBmaWxsPSIjZmVjYzAwIi8+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIyIiB5PSI0IiBmaWxsPSIjZmVjYzAwIi8+Cjwvc3ZnPgo=";